<template>
  <div class="multi-sub-ext">
    <label>
      <input type="radio" v-model="selectedOpt" value="1"><i></i>
      <strong>{{ formatPrice(item, 'renewPrice') }}</strong> for 30 days
    </label>
    <label>
      <input type="radio" v-model="selectedOpt" value="2"><i></i>
      <strong>{{ formatPrice(item, 'renewPrice2') }}</strong> for 90 days
    </label>
    <label>
      <input type="radio" v-model="selectedOpt" value="3"><i></i>
      <strong>{{ formatPrice(item, 'renewPrice3') }}</strong> for 1 year
    </label>
    <a class="subscbtn" href="" v-on:click.prevent="selectedOpt && $emit('select', selectedOpt)">Extend</a>
  </div>

</template>

<script>
import formatters from './formatters';
export default {
  mixins: [formatters],
  props: ["item"],
  data: ()=>({
    selectedOpt: null,
  }),
}
</script>
